import { camelCase, upperFirst } from "lodash-es";

export { default as slugify } from "@sindresorhus/slugify";
export { capitalize, kebabCase, snakeCase, trim, trimStart, truncate } from "lodash-es";

export function pascalCase(str: string) {
  return upperFirst(camelCase(str));
}
